import "./App.css";

import { ThemeProvider, createTheme } from "@mui/material/styles";

import CheckboxCheckedIcon from "./assets/Icons/CheckboxCheckedIcon";
import CheckboxUncheckedIcon from "./assets/Icons/CheckboxUncheckedIcon";
import PropTypes from "prop-types";
import { useTheme } from "./hooks/useTheme";

function Theme(props) {
  const { children } = props;

  // const { data } = useQuery({
  //   queryKey: ["welcome"],
  // });
  const { theme: themeConfig } = useTheme();

  const theme = createTheme({
    palette: {
      primary: {
        main: themeConfig?.primary ?? "#ffc72c",
        contrastText: "#12284a",
      },
      secondary: {
        main: themeConfig?.secondary ?? "#12284a",
      },
      neutral: {
        main: themeConfig?.neutral ?? "#efede7",
      },
      error: {
        main: themeConfig?.error ?? "#b0001f",
      },
    },
    typography: {
      MuiCssBaseline: {
        styleOverrides: `@font-face {
          font-family: 'Geist';
          font-style: normal;
          font-weight: 400;
        }`,
      },
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            backgroundColor: themeConfig?.background ?? "#EFEDE7",
            borderColor: "#C2C1BF",
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {},
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginLeft: "0px",
            fontWeight: 700,
            fontSize: "12px",
          },
        },
      },
      MuiCheckbox: {
        defaultProps: {
          icon: <CheckboxUncheckedIcon />,
          checkedIcon: <CheckboxCheckedIcon />,
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {
            marginLeft: "1rem",
            marginRight: "1rem",
            "&:focus": {
              outline: "none",
            },
          },
        },
      },
      MuiBox: {
        styleOverrides: {
          root: {
            "&:focus-visible": {
              outline: "none",
            },
          },
        },
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

Theme.propTypes = {
  children: PropTypes.node,
};

export default Theme;
